import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';
import { ChatbotSettingsInterface, ResponseChatbotSettingsInterface } from 'interfaces/chatbot-settings.interface';
import { RootState } from 'redux/store';

const initialState: ResponseChatbotSettingsInterface = {
  hasNextPage: false,
  hasPrevPage: false,
  limit: 0,
  nextPage: 0,
  page: 0,
  pagingCounter: 0,
  prevPage: 0,
  totalDocs: 0,
  totalPages: 0,
  docs: [],
};

export const chatbotSettingsSlice = createSlice({
  name: 'chatbotSettings',
  initialState,
  reducers: {
    setChatbotSettings: (
      state: Draft<ResponseChatbotSettingsInterface>,
      action: PayloadAction<ResponseChatbotSettingsInterface>
    ) => {
      return action.payload;
    },
    deleteChatbotSettings: (state: Draft<ResponseChatbotSettingsInterface>, action: PayloadAction<string>) => {
      const { docs: chatbotSettings } = state;
      const updatedChatbotSettings = chatbotSettings.filter((u: ChatbotSettingsInterface) => u._id !== action.payload);
      return { ...state, docs: updatedChatbotSettings, totalDocs: updatedChatbotSettings?.length };
    },
  },
});

export const { setChatbotSettings, deleteChatbotSettings } = chatbotSettingsSlice.actions;

export const selectChatbotSettings = (state: RootState) => state.chatbotSettings;

export const chatbotSettingsReducer = chatbotSettingsSlice.reducer;
